import React from 'react';
import styled from 'styled-components';
import { Container, Media } from '../../components';
import { LifeAtGlossierDesktop } from './desktop';
import { LifeAtGlossierMobile } from './mobile';
import { LifeAtGlossierTablet } from './tablet';

const DesktopWrapper = styled.div`
  background-color: #fff;
`;

export const LifeAtGlossier = React.forwardRef<any>((props, ref) => {
  return (
    <section ref={ref}>
      <Container>
        <Media at="sm">
          <LifeAtGlossierMobile />
        </Media>
      </Container>
      <Container>
        <Media at="md">
          <LifeAtGlossierTablet />
        </Media>
      </Container>
      <DesktopWrapper>
        <Container>
          <Media greaterThanOrEqual="xmd">
            <LifeAtGlossierDesktop />
          </Media>
        </Container>
      </DesktopWrapper>
    </section>
  );
});
